import React from "react";
import "./ListHeading.scss";
import { IoIosArrowForward } from "react-icons/io";
import { NavLink } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";

const ListHeading = ({
  dataTableHeadingText,
  dataTableHeadingIcon,
  dataTablePageLink,
  dataTableHeadingReactIcon,
  imgHeight,
  imgWidth,
  reactIconColor
}) => {
  const isDarkColor = (color) => {
    if (!color) return false;
    const darkColors = ["#000000", "#323232", "black"];
    return darkColors.includes(color.toLowerCase().trim());
  };
  let title = [];
  let icons = [];
  let links = [];

  dataTableHeadingText instanceof Array
    ? (title = [...title, ...dataTableHeadingText])
    : title.push(dataTableHeadingText);

  dataTableHeadingIcon instanceof Array
    ? (icons = [...icons, ...dataTableHeadingIcon])
    : icons.push(dataTableHeadingIcon);

  dataTablePageLink instanceof Array
    ? (links = [...links, ...dataTablePageLink])
    : links.push(dataTablePageLink);

  return (
    <div className="d-flex flex-row justify-content-start align-items-center">
      {title.map((titles, index) => (
        <div className="d-flex align-items-center text-decoration-none" key={index}>
          {dataTableHeadingReactIcon && (
            <div 
              className={`me-3 main-heading-image ${isDarkColor(reactIconColor) ? "is-dark-logo" : ""}`} 
              style={{ color: reactIconColor }}
            >
              {dataTableHeadingReactIcon}
            </div>
          )}
          {dataTableHeadingIcon && icons[index] && (
            <img
              src={icons[index]}
              alt="icon"
              id="center-blueShadow"
              className="me-3 main-heading-image"
              style={{ 
                height: imgHeight ? imgHeight : "", 
                width: imgWidth ? imgWidth : "" 
              }}
            />
          )}
          <h2 className="main-heading pe-2">{titles}</h2>
        </div>
      ))}
    </div>
  );
};

export default ListHeading;
